/*
|--------------------------------------------------------------------------
| Utility: getImageUrl.js
| Author: Sayed Ahmed
| Description: Returns the full image URL based on a given path. If the path
|              is missing, returns a fallback placeholder image instead.
|--------------------------------------------------------------------------
*/

/**
 * Constructs a full image URL using the environment base path.
 * Returns a fallback image if no path is provided.
 *
 * @param {string|null|undefined} path - The relative path of the image.
 * @returns {string} Full image URL or fallback placeholder.
 */
export default function getImageUrl(path) {
  const baseUrl = process.env.REACT_APP_VERSEL_API;  // From .env (e.g., https://api.example.com/storage)
  const fallbackImage = "/placeholder.jpg";          // Local default image

  if (!path) return fallbackImage;

  return `${baseUrl}/${path}`;
}
